import { render, staticRenderFns } from "./businessIndicatorsLQZ.vue?vue&type=template&id=706ccd98&scoped=true"
import script from "./businessIndicatorsLQZ.vue?vue&type=script&lang=js"
export * from "./businessIndicatorsLQZ.vue?vue&type=script&lang=js"
import style0 from "./businessIndicatorsLQZ.vue?vue&type=style&index=0&id=706ccd98&prod&lang=scss&scoped=true"
import style1 from "./businessIndicatorsLQZ.vue?vue&type=style&index=1&id=706ccd98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ccd98",
  null
  
)

export default component.exports